////////////////////////////////////////////////////////////
//
// Component for apps Images
//
////////////////////////////////////////////////////////////
(() => {
    class Image extends App.Component {
        constructor(container) {
            super(container);
        }

        swapWithAlternativeImage() {
            this.alternativeImage = this.read('src');
            if (this.alternativeImage) {
                this.container.setAttribute('src', this.alternativeImage);
                this.alternativeImage = null;
            }
            return this;
        }
    }
    App.Components.register('img', Image);
})();
